import { connect } from 'react-redux';
import QuestionPage from './QuestionPage';
import { getQuestionFromTags } from '../../reducers';
import { getTagsFromPath } from '../../helpers';

const mapStateToProps = (state, ownProps) => {
  const { location: { pathname }, history } = ownProps;
  const { tags: allTags } = state;

  const tags = getTagsFromPath(pathname);

  const question = (tags.length > 0) ? getQuestionFromTags(state.questions, tags) : state.questions[0];

  return {
    history,
    question,
    tags,
    allTags,
  };
};


const QuestionPageConnector = connect(
  mapStateToProps,
)(QuestionPage);

export default QuestionPageConnector;


// WEBPACK FOOTER //
// ./src/components/question-page/QuestionPageConnector.js